import 'babel-polyfill';
import React from "react";
import ReactDOM from "react-dom";
import "./index.scss";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { HashRouter } from "react-router-dom";

ReactDOM.render(
  <HashRouter basename={process.env.REACT_APP_BASENAME}>
    <App />
  </HashRouter>,
  document.getElementById("root")
);

serviceWorker.unregister();


// basename='/calculadora-nuevo'
// basename='/t1/calculadora-nuevo'